<iw-info-dialog-content
  status="failed"
  [title]="'ordersHistory.cancel.dialog.title' | translate"
>
  <div afterTitle>
    <p class="subtitle text-center">
      {{ "ordersHistory.cancel.dialog.message" | translate }}
    </p>
    <div class="actions">
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="secondary"
        (click)="cancel()"
      >
        {{ "ordersHistory.cancel.dialog.btn.cancel" | translate }}
      </iw-button>
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="primary"
        (click)="confirm()"
      >
        {{ "ordersHistory.cancel.dialog.btn.confirm" | translate }}
      </iw-button>
    </div>
  </div>
</iw-info-dialog-content>
